import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { Tweet as TweetType } from '@/types/tweet';
import type { InlineTweetReference, TweetSummarySectionItem } from '../types';
import { dedupeStrings } from '../utils';
export interface TopicSummaryResult {
  items: TweetSummarySectionItem[];
  keywords: string[];
  referenceCount: number;
}
export function useTopicSummary(t0) {
  const $ = _c(11);
  const {
    tweet,
    inlineTweetUrls
  } = t0;
  const entityBundle = tweet.entities;
  let items;
  let keywords;
  if ($[0] !== entityBundle || $[1] !== inlineTweetUrls.length || $[2] !== tweet.contextAnnotations) {
    const hashtagEntities = Array.isArray(entityBundle?.hashtags) ? entityBundle.hashtags : [];
    const cashtagEntities = Array.isArray(entityBundle?.cashtags) ? entityBundle.cashtags : [];
    const mentionEntities = Array.isArray(entityBundle?.mentions) ? entityBundle.mentions : [];
    const contextAnnotations = Array.isArray(tweet.contextAnnotations) ? tweet.contextAnnotations : [];
    const hashtags = dedupeStrings(hashtagEntities.map(_temp));
    const cashtags = dedupeStrings(cashtagEntities.map(_temp2));
    const mentions = dedupeStrings(mentionEntities.map(_temp3));
    const contextDomains = dedupeStrings(contextAnnotations.map(_temp4));
    const contextEntities = dedupeStrings(contextAnnotations.map(_temp5));
    keywords = [...hashtags, ...cashtags, ...contextEntities];
    items = [];
    if (hashtags.length > 0) {
      items.push({
        label: "Hashtags",
        value: hashtags.map(_temp6).join(", ")
      });
    }
    if (cashtags.length > 0) {
      items.push({
        label: "Cashtags",
        value: cashtags.map(_temp7).join(", ")
      });
    }
    if (mentions.length > 0) {
      items.push({
        label: "Mentions",
        value: mentions.map(_temp8).join(", ")
      });
    }
    if (contextDomains.length > 0) {
      items.push({
        label: "Context domains",
        value: contextDomains.join(", ")
      });
    }
    if (contextEntities.length > 0) {
      items.push({
        label: "Context entities",
        value: contextEntities.join(", ")
      });
    }
    if (inlineTweetUrls.length > 0) {
      const t1 = String(inlineTweetUrls.length);
      let t2;
      if ($[5] !== t1) {
        t2 = {
          label: "Inline references",
          value: t1,
          emphasis: "muted"
        };
        $[5] = t1;
        $[6] = t2;
      } else {
        t2 = $[6];
      }
      items.push(t2);
    }
    $[0] = entityBundle;
    $[1] = inlineTweetUrls.length;
    $[2] = tweet.contextAnnotations;
    $[3] = items;
    $[4] = keywords;
  } else {
    items = $[3];
    keywords = $[4];
  }
  let t1;
  if ($[7] !== inlineTweetUrls.length || $[8] !== items || $[9] !== keywords) {
    t1 = {
      items,
      keywords,
      referenceCount: inlineTweetUrls.length
    };
    $[7] = inlineTweetUrls.length;
    $[8] = items;
    $[9] = keywords;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1 satisfies TopicSummaryResult;
}
function _temp8(username) {
  return `@${username}`;
}
function _temp7(tag_0) {
  return `$${tag_0}`;
}
function _temp6(tag) {
  return `#${tag}`;
}
function _temp5(annotation_0) {
  return annotation_0.entity?.name ?? annotation_0.entity?.description ?? null;
}
function _temp4(annotation) {
  return annotation.domain?.name ?? annotation.domain?.description ?? null;
}
function _temp3(mention) {
  return mention.username;
}
function _temp2(cashtag) {
  return cashtag.tag;
}
function _temp(hashtag) {
  return hashtag.tag;
}